import LogisticsConfiguration from "@/components/logistics/configuration/logistics-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/logistics",
)({
  component: LogisticsSettingsPage,
});

function LogisticsSettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "logistics_configurations", actions: ["read", "update"] },
      ]}
    >
      <div className="gap-2 flex-col flex">
        <LogisticsConfiguration module="logistics_configurations" />
      </div>
    </RouteGuardPermissions>
  );
}
